export enum ZustandStorageKeys {
  AssetComparisonPlayer = 'zustand/assetComparison/player',
  AssetModal = 'zustand/assetModal',
  AssetModalPlayer = 'zustand/assetModal/player',
  BoardGenerateHintDismissed = 'zustand/boardGenerateHintDismissed',
  ContextSourcesFieldTable = 'zustand/contextSourcesFieldTable',
  ContextSourcesView = 'zustand/contextSourcesView',
  CreativePerformance = 'zustand/creativePerformance',
  CreativePerformanceAdStatusFilter = 'zustand/creativePerformance/adStatusFilter',
  CreativePerformanceAdsTableColumns = 'zustand/creativePerformance/adsTableColumns',
  CreditUsageDismissedAlerts = 'zustand/dismissedAlerts/creditUsage',
  CreditUsageDismissedAlertsSession = 'zustand/dismissedAlerts/creditUsage/session',
  DevTools = 'zustand/devTools',
  SubSideNavBrowseLastPath = 'zustand/subSideNavBrowseLastPath',
  MainSideNav = 'zustand/mainSideNav',
  OnboardingPreferences = 'zustand/onboardingPreferences',
  PendingEmailCooldown = 'zustand/pendingEmail/cooldown',
  SkillOnboardingPendingRun = 'zustand/skillOnboarding/pendingRun',
  WorkspaceAgentMentionPicker = 'zustand/workspaceAgentMentionPicker',
  WorkspaceAgentPanel = 'zustand/workspaceAgentPanel',
  WorkspaceRightPanel = 'zustand/workspaceRightPanel',
  SubSideNav = 'zustand/subSideNav',
  WorkspaceSidebar = 'zustand/workspaceSidebar',
  WorkspaceSidebarLibraries = 'zustand/workspaceSidebar/libraries',
  WorkspaceSidebarSectionFavoriteBoards = 'zustand/workspaceSidebar/section/favoriteBoards',
  WorkspaceSidebarSectionSavedSearches = 'zustand/workspaceSidebar/section/savedSearches',
  WorkspaceSidebarSectionSearchAll = 'zustand/workspaceSidebar/section/searchAll',
  WorkspaceSidebarSectionLibraries = 'zustand/workspaceSidebar/section/libraries',
  WorkspaceSidebarSectionRecentCanvases = 'zustand/workspaceSidebar/section/recentCanvases',
  WorkspaceSidebarSectionWorkspaceBoards = 'zustand/workspaceSidebar/section/workspaceBoards',
  WorkspaceSidebarWorkspaceBoards = 'zustand/workspaceSidebar/workspaceBoards',
}
